import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Col, Container, Row, Card, CardBody, Button } from 'reactstrap';
import Modal from '@material-ui/core/Modal';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import SearchIcon from '@material-ui/icons/Search';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { withStyles } from "@material-ui/core/styles";
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import ReactTableInvoicesCostumer from './ReactTableInvoicesCostumer';
import Spinner from 'react-bootstrap/Spinner';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import history from '../../../../history';
import FormHelperText from '@material-ui/core/FormHelperText';
import BuildXml from '../../../ElectronicBilling/components/BuildXml';
import ElectronicBillingHTTP from '../../../ElectronicBilling/api/ElectronicBillingHTTP';
import TalummHTTP from '../../../ElectronicBilling/api/TalummHTTP';
import AlertModal from '../../../../shared/components/Modal';
import { InvoiceUtils } from '../SearchInvoiceCostumers/components/InvoiceUtils';
import ModalTemplatePdf from '../SearchInvoiceCostumers/components/ModalTemplatePDF';
import { TextField, InputBase } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

const styles = theme => ({
    date: {
        width: 400,
        fontFamily: 'Roboto',
        border: 'none',
        fontSize: 13,
        lineHeight: 1.6
    },
});

const renderField = ({
    input, disabled, placeholder, type, meta: { touched, error }, style
}) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above" style={style}>
        <input {...input} placeholder={placeholder} type={type} disabled={disabled} />
        {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
);

renderField.propTypes = {
    input: PropTypes.shape().isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
};

renderField.defaultProps = {
    placeholder: '',
    meta: null,
    type: 'text',
};

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '100%',
            color: '#4ce1b6'
        },
    },
    inputBase: {
        border: "1px solid #D2D6D3",
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(2),
        width: '100%',
        overflowY: 'auto',
        '&:hover': {
            border: "1px solid #4ce1b6",
        }
    },
    textfield: {
        padding: theme.spacing(1),
        width: '100%',
    }
}));


const AddInvoiceCostumer = (props) => {
    const [numNota, setNumNota] = useState(null);
    const [dates, setDates] = useState({ start: new Date(), end: new Date() });
    const [costumer, setCostumer] = useState('');
    const [costumers, setCostumers] = useState([]);
    const [errors, setErrors] = useState({});
    const [load, setLoad] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [openModalPDF, setOpenModalPDF] = useState(false);
    const [invoices, setInvoices] = useState([]);
    const [invoiceChecks, setInvoiceChecks] = useState([]);
    const [lastSearch, setLastSearch] = useState({});
    const [invoiceLoading, setInvoiceLoading] = useState(false);
    const [typeInvoice, setTypeInvoice] = useState(0);
    const [costumerContracts, setCostumerContracts] = useState([]);
    const [contract, setContract] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [successModal, setSuccessModal] = useState(false);
    const [successModal2, setSuccessModal2] = useState(false);
    const [errorModal, setErrorModal] = useState(false);
    const [errorModal2, setErrorModal2] = useState(false);
    const [errorModal3, setErrorModal3] = useState(false);
    const [esFactura, setEsFactura] = useState(true);
    const [noteInvoice, setNoteInvoice] = useState(null);
    const [thirdSelected, setThirdSelected] = useState(null)
    const classes = useStyles();

    useEffect(() => {
        if (props.location.state.numNota !== 0) {
            setNumNota(props.location.state.numNota);
        }
        setEsFactura(props.location.state.esFactura);
        loadCostumer();
    }, []);

    useEffect(() => {
        var InitialChecks = new Array(invoices.length).fill(true);
        setInvoiceChecks(InitialChecks);
    }, []);

    const loadDataCreditNote = () => {
        var data = { num_notac: numNota }
        fetch(process.env.REACT_APP_PUBLIC_URL + '/facturas/consultarncredito', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                if (data.existe) {
                    console.log(data.contenido[0]);

                } else {

                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    const loadCostumer = () => {
        let nuevaFactura = true;
        fetch(process.env.REACT_APP_PUBLIC_URL + 'tercero/listar?nueva_factura=' + nuevaFactura, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                setCostumers(data);
                setLoad(false);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    const validateSearch = () => {
        var errors = {};
        if (costumer === '') {
            errors.costumer = "Seleccione un cliente";
        } else {
            delete errors.costumer;
        }

        if (moment(dates.end).diff(dates.start) < 0) {
            errors.date = "Ingrese fechas adecuadas";
        } else {
            delete errors.date;
        }

        if (contract === null) {
            errors.contract = "Seleccione un contrato";
        } else {
            delete errors.contract;
        }

        console.log(errors);
        setErrors(errors);
        if (Object.keys(errors).length == 0) {
            return false;
        } else {
            return true;
        }
    };

    const searchInvoice = () => {
        if (!validateSearch()) {
            let fecha_inicial_facturacion = moment(dates.start).format("YYYY/MM/DD");
            let fecha_final_facturacion = moment(dates.end).format("YYYY/MM/DD");

            var data = {
                id_tercero: costumer,
                desde: moment(fecha_inicial_facturacion + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
                hasta: moment(fecha_final_facturacion + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss'),
                tipo: typeInvoice,
                id_plan: contract
            };

            if (JSON.stringify(data) !== JSON.stringify(lastSearch)) {
                setLastSearch(data);
                setLoad(true);
                fetch(process.env.REACT_APP_PUBLIC_URL + 'facturas/verificar', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                    },
                    body: JSON.stringify(data)
                })
                    .then(response => {
                        return response.json();
                    })
                    .then(data => {
                        if (data.existe) {
                            console.log(data);
                            setInvoices(data.facturas.result);
                            var InitialChecks = new Array(data.facturas.result.length).fill(true);
                            setInvoiceChecks(InitialChecks);
                            setLoad(false);
                            setOpenModal(true);
                        } else {
                            setInvoices([]);
                            setErrorModal3(true);
                            setLoad(false);
                        }
                    })
                    .catch((error) => {
                        setErrorModal3(true);
                        console.error('Error:', error);
                    });
            } else {
                if (invoices.length > 0) {
                    setOpenModal(true);
                } else {
                }
            }
        }
    }

    const createInvoice = async (selectedInvoices) => {
        setInvoiceLoading(true);
        let usuarioFacturador = JSON.parse(sessionStorage.getItem('usuario'));
        let fecha_inicial_facturacion = moment(dates.start).format("YYYY/MM/DD");
        let fecha_final_facturacion = moment(dates.end).format("YYYY/MM/DD");
        var data = {
            id_tercero: costumer,
            facturas_paciente: selectedInvoices,
            total: InvoicesSelectedInfo(invoices, invoiceChecks).total,
            fecha_inicial: moment(fecha_inicial_facturacion).format("YYYY/MM/DD"),
            fecha_final: moment(fecha_final_facturacion).format("YYYY/MM/DD"),
            id_plan: contract,
            es_factura: esFactura,
            id_usuario: usuarioFacturador.id_usuario,
            nota: noteInvoice
        }
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'facturas/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        }).then(response => {
            return response.json();
        }).then(data => {
            if (esFactura) {
                setInvoiceLoading(false);
                setSuccessModal(true);
                /*
                //OJO!! Factura Electronica aca
                generateElectronicInvoice(data.factura).then(res_invoice => {
                    setInvoiceLoading(false);
                    setSuccessModal(true);
                }).catch(err => {
                    setInvoiceLoading(false);
                    setSuccessModal2(true);
                    console.log(err);
                });
                */
            }
            else {
                setInvoiceLoading(false);
                setSuccessModal(true);
            }
        }).catch((error) => {
            setInvoiceLoading(false);
            setErrorModal(true);
            console.error('Error:', error);
        });
    }

    //Genera la Factura Electronica dependiendo del Provedor
    const generateElectronicInvoice = async (factura) => {
        let providerElectronicInvoice = await ElectronicBillingHTTP.getActualProvider();
        switch (parseInt(providerElectronicInvoice.id_factura_electronica_api)) {
            case 1: //Facturación Electronica con Factura Tech
                await generateXml(factura);
                return true;
            case 2://Facturación Electronica con Talumm
                await TalummHTTP.importInvoice(factura.factTercero.id_factura_t).then(resx => {
                    setInvoiceLoading(false);
                    return true;
                }).catch((err) => {
                    throw new Error(err);
                });
                break;
            default: //No tiene Facturación Electronica
                return false;
        }
    }

    const generateXml = async (data) => {

        const xml = BuildXml(data, "FACTURA", data.origen);

        const xmlBase64 = window.btoa((new XMLSerializer()).serializeToString(xml));

        let dataSend = { base64: xmlBase64 }
        /*
                await fetch(process.env.REACT_APP_PUBLIC_URL + 'factura-electronica/xml64', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                    },
                    body: JSON.stringify(dataSend)
                })
                    .then(response => {
                        return response.json();
                    })
                    .then(res => {
                        console.log(res);
                        documentStatus(res.return.transaccionID.$value);
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });*/
    }

    const getNumber = (value) => {

        let numStr = value.toString();

        let num = numStr.replace(/\./g, '');

        if (!isNaN(num)) {
            num = num.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1.');
            num = num.split('').reverse().join('').replace(/^[\.]/, '');
        }

        return num
    }

    const documentStatus = (transaccionID) => {

        let dataSend = { transaccionID: transaccionID }

        fetch(process.env.REACT_APP_PUBLIC_URL + 'factura-electronica/document-status-file', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                return response.json();
            })
            .then(res => {
                console.log(res);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    const InvoicesSelectedInfo = useCallback((invoices, invoiceChecks) => {
        var total = 0;
        var copago = 0;
        var num = 0;
        invoices.filter((invoice, index) => {
            if (invoiceChecks[index]) {
                copago += parseInt(invoice["total"]);
                total += parseInt(invoice["valor_tercero"]);
                num++;
            }
        })
        return { total: total, copago: copago, amount_bills: num };
    }, [invoices, invoiceChecks]);

    //Busca los CONTRATOS (Planes)
    const getContracts = async (thirdId) => {
        var data = { id: thirdId };
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'plan/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        }).then(response => {
            return response.json();
        }).then(data => {
            console.log("Tercero", data);
            if (data.existe) {
                setCostumerContracts(data.contenido);
            } else {
                setCostumerContracts([]);
            }
        }).catch((error) => {
            console.error('Error:', error);
        });
    }

    const handleChangeCustomer = (costumer) => {
        setCostumer(costumer.id_tercero);
        setContract(null);
        getContracts(costumer.id_tercero);
        setNoteInvoice(costumer.nota_factura ?? "");
        setThirdSelected(costumer);
        delete errors.costumer;
    }

    const handleChangeContract = (contractId) => {
        setContract(contractId);
        delete errors.contract;
    }

    const startInvoiceProcess = () => {
        let validated = validateSearch();
        if (!validated) {
            if (invoiceChecks.length <= 0) {
                setErrorModal2(true);
                return;
            }
            var selectedInvoices = invoices.filter((invoice, index) => invoiceChecks[index]).map((invoice) => invoice.id_recibo);
            createInvoice(selectedInvoices);
        }
    }

    const finishInvoiceProcess = () => {
        history.push({
            pathname: process.env.PUBLIC_URL + '/management/search-invoice-costumer'
        });
    }

    const invoicePrevisualization = async () => {
        let InvoiceUt = new InvoiceUtils();
        var idsReceipts = invoices.filter((invoice, index) => invoiceChecks[index]).map((invoice) => invoice.id_recibo);
        await InvoiceUt.getReceiptsById(idsReceipts, costumer, null).then((res) => {
            if (res != null) {
                setOpenModalPDF(true);
                InvoiceUt.generatePDFPrevisualizationInvoices(res.factura, esFactura, noteInvoice);
            }
            else {
                console.log("Error consultando la Previsualizacion de la Factura");
            }
        }).catch((error) => {
            console.log(error);
            setOpenModalPDF(false);
        });
    }

    return (<Container className="dashboard">
        <Row>
            <Col md={3}>
                <div className='button-tooltip-back-with-title'>
                    <div style={{margin: '0em 1em'}}>
                        <Tooltip
                            title="Regresar a la lista de Documentos Cliente"
                            style={{ padding: '2px', backgroundColor: '#55e5bb' }}
                        >
                            <IconButton
                                aria-label="upload picture"
                                component="span"
                                className='tooltip-top'
                                onClick={() => {
                                    history.push({
                                        pathname: process.env.PUBLIC_URL + '/management/search-invoice-costumer'
                                    });
                                }}
                            >
                                <ArrowBackIcon style={{ color: '#153365' }} />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <div>
                        <h3 style={{ marginBottom: 30 }}>Crear {esFactura ? 'Factura' : 'Cuenta de Cobro'}</h3>
                    </div>
                </div>
            </Col>
        </Row>
        <Row>
            <Card>
                <CardBody>
                    <Row className='form-add-invoice-costumer'>
                        <Col md={8}>
                            <FormControl style={{ width: '100%' }} className="medical-material-form__field" >
                                <InputLabel required id="demo-simple-select-label"  >Cliente</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="id-simple-select"
                                    value={thirdSelected}
                                    onChange={e => handleChangeCustomer(e.target.value)}
                                    style={{ width: '100%' }}
                                    error={errors.hasOwnProperty("costumer") ? errors.costumer !== "" : false}
                                >
                                    {costumers.map(costumer => {
                                        return <MenuItem key={costumer.id_tercero} value={costumer}>{costumer.nombre}</MenuItem>
                                    })}
                                </Select>
                                <FormHelperText>{errors.hasOwnProperty("costumer") ? <b className="text-danger">{errors.costumer}</b> : ''}
                                </FormHelperText>
                            </FormControl>
                        </Col>
                        <Col md={4}>
                            <FormControl style={{ marginRight: 10, width: '100%' }} className="medical-material-form__field" >
                                <InputLabel required id="demo-simple-select-label" >Contrato</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="id-simple-select"
                                    value={contract}
                                    onChange={e => handleChangeContract(e.target.value)}
                                    style={{ width: '100%' }}
                                    error={errors.hasOwnProperty("contract") ? errors.contract !== "" : false}
                                >
                                    {costumerContracts.map(cosContract => {
                                        return <MenuItem key={cosContract.id_plan} value={cosContract.id_plan}>{cosContract.nombre}</MenuItem>
                                    })}
                                </Select>
                                <FormHelperText>{errors.hasOwnProperty("contract") ? <b className="text-danger">{errors.contract}</b> : ''}
                                </FormHelperText>
                            </FormControl>
                        </Col>
                        <Col md={4}>
                            <FormControl style={{ marginRight: 10, width: '100%' }} className="medical-material-form__field">
                                <InputLabel required id="demo-simple-select-label" >Tipo de Factura</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="id-simple-select"
                                    value={typeInvoice}
                                    onChange={e => setTypeInvoice(e.target.value)}
                                    style={{ width: '100%' }}
                                >
                                    <MenuItem key={0} value={0}>Consultas y Procedimientos</MenuItem>
                                    <MenuItem key={1} value={1}>Consultas</MenuItem>
                                    <MenuItem key={2} value={2}>Procedimientos</MenuItem>
                                </Select>
                            </FormControl>
                        </Col>
                        <Col md={4}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <DatePicker
                                    className="medical-material-form__field"
                                    disableFuture
                                    label="Fecha desde"
                                    views={["year", "month", "date"]}
                                    value={dates.start}
                                    onChange={(date) => {
                                        setDates({ ...dates, start: date });
                                    }}
                                    animateYearScrolling
                                    format="yyyy/MM/D"
                                    style={{ marginRight: 10, width: '100%' }}
                                />
                            </MuiPickersUtilsProvider>
                        </Col>
                        <Col md={4}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <DatePicker
                                    className="medical-material-form__field"
                                    disableFuture
                                    label="Fecha hasta"
                                    views={["year", "month", "date"]}
                                    value={dates.end}
                                    onChange={(date) => {
                                        setDates({ ...dates, end: date });
                                    }}
                                    animateYearScrolling
                                    format="yyyy/MM/D"
                                    style={{ width: '100%' }}
                                />
                            </MuiPickersUtilsProvider>
                        </Col>
                        <Col md={12}>
                            <br />
                            {/* <div className="form">
                                <div className="form__form-group">
                                    <span className="form__form-group-label">
                                        Nota
                                    </span>
                                    <div className="form__form-group-field">
                                        <textarea
                                            value={noteInvoice}
                                            name="textarea-cancel"
                                            onChange={(e) => {
                                                setNoteInvoice(e.target.value);
                                            }}
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </div> */}
                            <span className="form__form-group-label">
                                Nota
                            </span>
                            <InputBase
                                className={classes.inputBase}
                                id="outlined-textarea"
                                placeholder="Nota"
                                rows={4}
                                value={noteInvoice}
                                multiline
                                variant="outlined"
                                onChange={(e) => {
                                    setNoteInvoice(e.target.value);
                                }}
                            />
                            {/*  <TextField
                                id="outlined-multiline-flexible"
                                className={classes.textfield}
                                label="Nota"
                                multiline
                                rows={4}
                                value={noteInvoice}
                                onChange={(e) => {
                                    setNoteInvoice(e.target.value);
                                }}
                                variant="outlined"
                            /> */}
                        </Col>
                    </Row>
                    <Row className='form-add-invoice-costumer'>
                        <Col>
                            <Button
                                style={{ marginTop: 10 }}
                                size="sm"
                                color="primary"
                                onClick={() => {
                                    searchInvoice();
                                }}>
                                <SearchIcon />
                            </Button>
                            <Button
                                style={{ marginLeft: 10, marginTop: 10 }}
                                size="sm"
                                disabled={invoiceLoading}
                                color="primary"
                                onClick={() => {
                                    startInvoiceProcess();
                                }}
                            >
                                {esFactura ? 'Generar Factura' : 'Generar Cuenta de Cobro'}
                            </Button>

                        </Col>
                    </Row>
                    <Row className='form-add-invoice-costumer'>
                        <Col>
                            <div style={{ marginTop: 20 }}>

                                <div style={{ fontSize: 15 }}>Número de Facturas: {!load && InvoicesSelectedInfo(invoices, invoiceChecks).amount_bills}</div>
                                <div style={{ fontSize: 15 }}>Subtotal: $ {!load && getNumber(InvoicesSelectedInfo(invoices, invoiceChecks).total + InvoicesSelectedInfo(invoices, invoiceChecks).copago)}</div>
                                <div style={{ fontSize: 15 }}>Copago: $ {!load && getNumber(InvoicesSelectedInfo(invoices, invoiceChecks).copago)}</div>
                                <div style={{ fontSize: 15 }}>Total: $ {!load && getNumber(InvoicesSelectedInfo(invoices, invoiceChecks).total)}</div>

                                {invoiceLoading ? (<Spinner animation="border" variant="success" />) : null}
                            </div>
                        </Col>
                    </Row>

                    <Modal
                        open={openModal}
                        onClose={e => {
                            setOpenModal(false)
                        }}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        style={{ zIndex: 1000 }}
                    >
                        <div>
                            <div
                                style={{
                                    position: 'absolute',
                                    width: '90%',
                                    height: '90%',
                                    backgroundColor: 'white',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%,-50%)',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    flexDirection: 'column',
                                }}
                            >
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    height: '75%',
                                    paddingRight: 10,
                                }}
                                >
                                    <div style={{
                                        flex: 1,
                                        overflowY: 'scroll',
                                        padding: 10
                                    }}>

                                        <ReactTableInvoicesCostumer
                                            invoices={invoices}
                                            invoiceChecks={invoiceChecks}
                                            setInvoiceChecks={setInvoiceChecks}
                                        />
                                    </div>
                                </div>
                                <div style={{ position: "relative", left: "3%", top: "1%" }}>
                                    <hr style={{ width: '30%' }} />
                                    <h5> <b>Subtotal: </b>
                                        $ {getNumber(InvoicesSelectedInfo(invoices, invoiceChecks).copago + InvoicesSelectedInfo(invoices, invoiceChecks).total)}
                                    </h5>
                                    <h5> <b>Copago: </b> $ {getNumber(InvoicesSelectedInfo(invoices, invoiceChecks).copago)}</h5>
                                    <h5> <b>Total: </b> $ {getNumber(InvoicesSelectedInfo(invoices, invoiceChecks).total)}</h5>
                                    <Button
                                        style={{ marginLeft: 10, marginTop: 10 }}
                                        color="secondary"
                                        onClick={() => {
                                            setOpenModal(false)
                                        }}
                                    >
                                        Cerrar
                                    </Button>

                                    <Button
                                        style={{ marginLeft: 10, marginTop: 10 }}
                                        color="primary"
                                        onClick={() => {
                                            invoicePrevisualization();
                                        }}
                                    >
                                        Previsualizar
                                    </Button>
                                </div>
                                <br />
                            </div>
                        </div>
                    </Modal>
                </CardBody>
            </Card>
        </Row>

        <AlertModal
            color="warning"
            title="Al crear esta Factura, se cerraran las Admisiones, desea continuar con la Facturación?"
            modal={showModal}
            onOk={() => startInvoiceProcess()}
            toggle={() => setShowModal(false)}
        />

        <AlertModal
            color="success"
            title="Facturación Realizada correctamente"
            modal={successModal}
            onOk={() => finishInvoiceProcess(false)}
            toggle={() => setSuccessModal(false)}
        />

        <AlertModal
            color="success"
            title="Factura Creada Correctamente, queda pendiente el Proceso de Facturación Electronica"
            modal={successModal2}
            onOk={() => finishInvoiceProcess(false)}
            toggle={() => setSuccessModal2(false)}
        />

        <AlertModal
            color="danger"
            title="Ha ocurrido un error al realizar la Facturación"
            modal={errorModal}
            onOk={() => setErrorModal(false)}
            toggle={() => setErrorModal(false)}
        />

        <AlertModal
            color="danger"
            title="No se seleccionaron Recibos de Caja para generar la factura"
            modal={errorModal2}
            onOk={() => setErrorModal2(false)}
            toggle={() => setErrorModal2(false)}
        />

        <AlertModal
            color="danger"
            title="No hay Recibos de Caja con los Filtros Seleccionados"
            modal={errorModal3}
            onOk={() => setErrorModal3(false)}
            toggle={() => setErrorModal3(false)}
        />

        <ModalTemplatePdf openModal={openModalPDF} closeModal={() => setOpenModalPDF(false)} />

    </Container>);
}

export default reduxForm({
    form: 'add_invoice_costumer_form', // a unique identifier for this form
})(withStyles(styles, { withTheme: true })(withTranslation('common')(AddInvoiceCostumer)));

